import { Chip, FormControl, InputLabel, MenuItem, Stack } from "@mui/material";
import Select, { SelectProps } from "@mui/material/Select";
import { useAppSelector } from "Hooks/useRedux";
import { DAYS } from "Constants/App";
import MenuButton from "../Pages/Home/Toolbox/Button";

interface IProps extends SelectProps {
  setData: (value: number) => void;
  setFormData: (value: any) => void;
  activeDays?: number[];
}

interface IDayTime {
  start_time?: string;
  end_time?: string;
  interval?: string;
  price?: string;
  eta?: string;
}

export default function StationPicker(props: IProps) {
  const { setData, setFormData, label, size, activeDays } = props;
  const { ids, stations } = useAppSelector((state) => state.stations);

  const handleChange = (event: any) => {
    const { value } = event.target;
    setFormData((prev: IDayTime) => ({ ...prev, source_station_id: value }));
    setData(value);
  };

  const newDays = activeDays ? DAYS.filter((d) => activeDays.includes(d.id)) : DAYS;

  return (
    <FormControl fullWidth size={size}>
      <InputLabel id="demo-simple-select-station-label">{label}</InputLabel>
      <Select {...props} onChange={handleChange}>
        {stations.map((s) => (
          <MenuItem key={s.id} value={s.id}>
            {s.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
